import React from "react";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";

import AuthLayout from "../../layouts/Auth.layout";
import { AuthWrapper, LoginForm } from "../../components/forms/auth";
import { ROUTES } from "../../routes";
import { ContactCard } from "../../components/cards/ContactCard";
import { selectContactLink } from "../../store/reducers/contacts";

export const Login = () => {
  const contactLink = useSelector(selectContactLink);

  return (
    <AuthLayout>
      <AuthWrapper form={<LoginForm />}>
        {contactLink && (
          <ContactCard
            title="You are invited by"
            text={contactLink.from_user_name}
            className="mb-16"
          />
        )}

        <div className="font-poppins text-5xl	text-gray-500 mb-8">Log In</div>

        <div className="font-manrope text-base text-gray-300 flex flex-row gap-x-6">
          <span>Don't have an account?</span>

          <NavLink
            to={ROUTES.AUTH_SIGNUP_DEFAULT}
            className="theme-link"
            data-test="sign-up-link"
          >
            Sign Up
          </NavLink>
        </div>
      </AuthWrapper>
    </AuthLayout>
  );
};
